import { useHistory, useLocation } from 'react-router-dom';

export const useRemoveQueryParams = (): ((params: string[]) => void) => {
  const history = useHistory();
  const location = useLocation();

  const removeParams = (params: string[]): void => {
    const currentParams = new URLSearchParams(location.search);
    params.forEach((param) => {
      currentParams.delete(param);
    });
    history.replace({
      pathname: location.pathname,
      search: currentParams.toString(),
    });
  };

  return removeParams;
};
